import { ITerminalDto } from "../models/TerminalDto";

export class TerminalsUtils {

  public static checkSameTerminalType(terminals: ITerminalDto[] | null): boolean {
    if (terminals) {
      for (let i = 1; i < terminals.length; i++) {
        if (terminals[0].terminalType !== terminals[i].terminalType) {
          return false;
        }
      }
    }
    return true;
  }
}
